<div class="general">
    <div class="animation">
        <iframe src="https://embed.lottiefiles.com/animation/134845"></iframe>
    </div>
    <div class="text-area text-uppercase text-center">
        <h1>404</h1>
        <h5>PAGE NOT FOUND !</h5>
        <p class="text-muted">Página Não Encontrada.</p>
    </div>
</div>

